const consts = {
    addFiles: {
        maxFiles: 1,
        maxSizeMB: 2,
    },
};

export default consts;
